import {
  ChevronLeftIcon,
  ChevronRightIcon,
  SearchIcon,
} from "@heroicons/react/outline";
import { ItemsHeaderProps } from "./types";

export const ItemsHeader = ({
  headerIcon,
  header,
  subheader,
  children,
  empty,
  emptyMessage,
  actionButton,
  searchValue,
  onSearchChange,
  currentPage,
  onPrevPage,
  onNextPage,
  itemsLength,
  itemsPerPage,
  searchPlaceholder,
}: ItemsHeaderProps) => {
  return (
    <div>
      {header && (
        <div className="flex py-2">
          <div className="flex-1">
            <h1 className="text-lg text-gray-900">
              {headerIcon}
              {header}
            </h1>
            <h2 className="text-sm text-gray-500">{subheader}</h2>
          </div>
          {actionButton}
        </div>
      )}
      <div className="border-b py-2">
        <div className="flex items-center">
          <div className="flex flex-1 items-center rounded-sm px-1">
            <SearchIcon
              className="mr-2 h-5 w-auto text-gray-400"
              aria-hidden="true"
            />
            <input
              type="text"
              placeholder={`Search ${searchPlaceholder}...`}
              value={searchValue}
              onChange={onSearchChange}
              className="block w-full rounded-sm border-0 border-transparent focus:border-transparent focus:ring-0 sm:text-sm"
            />
          </div>
          {(currentPage !== 1 || currentPage * itemsPerPage < itemsLength) && (
            <div className="flex items-center space-x-1 px-1">
              <button
                onClick={onPrevPage}
                disabled={currentPage === 1}
                className={`rounded-full border p-1.5 ${
                  currentPage === 1 ? "bg-gray-200 opacity-50" : "bg-white"
                }`}
              >
                <ChevronLeftIcon className="h-4 w-4" />
              </button>
              <button
                onClick={onNextPage}
                disabled={currentPage * itemsPerPage >= itemsLength}
                className={`rounded-full border p-1.5 ${
                  currentPage * itemsPerPage >= itemsLength
                    ? "bg-gray-200 opacity-50"
                    : "bg-white"
                }`}
              >
                <ChevronRightIcon className="h-4 w-4" />
              </button>
            </div>
          )}
        </div>
      </div>
      {empty &&
        (typeof emptyMessage === "string" ? (
          <div className="flex items-center justify-center pb-8 pt-2">
            <span className="text-sm text-gray-500">{emptyMessage}</span>
          </div>
        ) : (
          emptyMessage
        ))}
      {children}
    </div>
  );
};
